import { createFileRoute } from '@tanstack/react-router';

// relative imports
import PostLoginPasswordChange from '../../components/shared/authentication/PostLoginPasswordChange';

type AuthErrorSearch = {
  unauthorized_error?: boolean;
  session_token?: string;
  state?: string;
};

export const Route = createFileRoute('/_public/pw-change-required')({
  validateSearch: (search: Record<string, unknown>): AuthErrorSearch => ({
    unauthorized_error: search.unauthorized_error as boolean,
    session_token: search.session_token as string,
    state: search.state as string,
  }),
  component: PostLoginPasswordChange,
  staticData: {
    accountOptional: true,
    hideHeader: true,
    meta: {
      title: 'Change Password | Ledgible',
    },
  },
});
